/* ABC: цена со скидкой одной строкой — «~~$299.00~~ $259.00 −13%»
   (вариант, выбранный владельцем 22.09). Процент считаем из двух цен. */
(function () {
  function num(t) { var m = (t || '').replace(/[^\d.,]/g, '').replace(/,(?=\d{3}\b)/g, '').replace(',', '.'); return parseFloat(m); }
  function apply(box) {
    var sale = box.querySelector('.price-item__group.price, .price');
    var old = box.querySelector('.compare-at-price');
    if (!sale || !old) return;
    var a = num(old.textContent), b = num(sale.textContent);
    if (!(a > b && b > 0)) return;
    var pct = Math.round((1 - b / a) * 100);
    var tag = box.querySelector('.abc-discount');
    if (!tag) { tag = document.createElement('span'); tag.className = 'abc-discount'; box.appendChild(tag); }
    if (tag.textContent !== '−' + pct + '%') tag.textContent = '−' + pct + '%';
    box.classList.add('abc-price-sale');
  }
  function scan() { document.querySelectorAll('product-price [ref="priceContainer"]').forEach(apply); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  var q = false;
  new MutationObserver(function () { if (q) return; q = true; setTimeout(function () { q = false; scan(); }, 50); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
